<template>
    <md-card>
        <md-card-header class="md-card-header-icon md-card-header-primary">
            <div class="card-icon">
                <md-icon v-text="icon"></md-icon>
            </div>
            <h4 class="title">
                <span v-text="title"></span>
                <span class="total" v-text="'(' + total + ')'"></span>
            </h4>
        </md-card-header>
        <md-card-content>
            <md-field md-clearable>
                <label>Search</label>
                <md-input v-model="activeSearch"/>
            </md-field>
            <md-table class="table-striped">
                <md-table-row>
                    <md-table-head class="index-table-head text-center" v-if="canSelected">#</md-table-head>
                    <slot name="head"></slot>
                </md-table-row>
                <slot/>
            </md-table>
        </md-card-content>
        <md-card-actions class="index-table-actions">
            <md-field class="per-page">
                <label>Per page</label>
                <md-select v-model="pageLimit">
                    <md-option v-for="(option, key) in pageLimitOptions" :key="key" :value="option">{{option}}
                    </md-option>
                </md-select>
            </md-field>
            <pagination v-model="activeNumberPage" :per-page="pageLimit" :total="total"/>
        </md-card-actions>
        <div v-if="loadingState" class="loader-container">
            <loader class="color"/>
        </div>
        <index-table-bulk-actions>
            <slot name="bulk-actions"/>
        </index-table-bulk-actions>
    </md-card>
</template>

<script>
    import {mapGetters, mapMutations} from "vuex";
    import Pagination from "../Pagination";
    import Loader from "../../../old/components/Loader";
    import IndexTableBulkActions from "./IndexTableBulkActions";
    import _ from 'lodash'

    export default {
        name: "IndexTable",
        components: {IndexTableBulkActions, Loader, Pagination},
        props: {
            endpoint: {
                type: String,
                required: true,
            },
            title: {
                type: String,
                required: true,
            },
            icon: {
                type: String,
                default: 'assignment'
            },
            canSelected: {
                type: Boolean,
                default: false,
            },
        },
        computed: {
            pageLimitOptions() {
                return [10, 25, 50];
            },
            activeSearch: {
                get() {
                    return this.search;
                },
                set(value) {
                    this.setSearch(value);
                }
            },
            activeNumberPage: {
                get() {
                    return this.pageNumber;
                },
                set(value) {
                    this.setPageNumber(value);
                }
            },
            ...mapGetters('indexTable', {
                sort: 'getSort',
                filter: 'getFilter',
                search: 'getSearch',
                pageNumber: 'getPageNumber',
                items: 'getItems',
                total: 'getTotal',
            })
        },
        data() {
            return {
                refreshTimer: null,
                loadingState: false,
                pageLimit: this.$cookies.get('perPage') ? Number(this.$cookies.get('perPage')) : 10,
            }
        },
        methods: {
            refreshData() {
                this.loadingState = true;

                this.$api[this.endpoint]({
                    data: {
                        page: {
                            number: this.pageNumber,
                            limit: this.pageLimit,
                        },
                        sort: this.sort,
                        filter: this.filter,
                        search: this.activeSearch,
                        filters: this.filters,
                    }
                }).then(({data}) => {
                    this.setItems(data.items);
                    this.setTotal(data.total);
                    this.loadingState = false;
                })
            },
            ...mapMutations('indexTable', {
                setSearch: 'setSearch',
                setPageNumber: 'setPageNumber',
                setItems: 'setItems',
                setTotal: 'setTotal',
                clearIndexTable: 'clearIndexTable',
            })
        },
        mounted() {
            this.$bus.on('updateIndex', this.refreshData);
            this.clearIndexTable();
        },
        watch: {
            search: _.debounce(function () {
                this.refreshData()
            }, 600),
            sort() {
                if (this.activeNumberPage === 1) {
                    if(!this.loadingState){
                        this.refreshData();
                    }
                } else {
                    this.activeNumberPage = 1;
                }
            },
            filter() {
                if (this.activeNumberPage === 1) {
                    if(!this.loadingState){
                        this.refreshData();
                    }
                } else {
                    this.activeNumberPage = 1;
                }
            },
            pageNumber: _.debounce(function () {
                this.refreshData()
            }, 400),
            pageLimit(value) {
                this.$cookies.set('perPage', value);

                if (this.activeNumberPage === 1) {
                    this.refreshData();
                } else {
                    this.activeNumberPage = 1;
                }
            }
        },
        beforeDestroy() {
            this.$bus.off('updateIndex');
        }
    }
</script>

<style lang="scss">
    .table-striped tbody > tr:nth-of-type(odd) {
        background-color: transparent !important;
    }

    .table-striped tbody > tr:nth-of-type(even) {
        background-color: #f9f9f9;
    }

    .title {
        .total {
            margin-left: 6px;
            opacity: .4;
        }
    }

    .index-table-actions {
        justify-content: space-between !important;

        .per-page {
            width: auto !important;
        }
    }

    .loader-container {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, .8);
        z-index: 1;
    }
</style>